import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=15a59d4c&scoped=true&"
import script from "./radio.vue?vue&type=script&lang=js&"
export * from "./radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a59d4c",
  null
  
)

export default component.exports